/**
 * Round an input element to an integer
 *
 * @return void
 */
(function ($) {
  function roundToStep() {
    // Get the current value
    var stringValue = $(this)
      .val()
      .replace(",", ".")
      .replace(/[^\d.]/g, "");

    // Check if the number if numeric
    if ($.isNumeric(stringValue) === true) {
      // Get the real value
      var value = parseFloat(stringValue);

      // Get the step
      var step = parseFloat($(this).attr("step"));

      // Update the input with the rounded value
      $(this).val(Math.round(value / step) * step);
    }
    $.fn["customSelect"].noConflict = function () {
      return $.fn["customSelect"];
    };
  }
  $.fn.roundToStep = roundToStep;
})(jQuery);
